import { t, type ErrorCodeMapperEntry } from "./types.js";

/** Error codes 49000-49999. One thousand-block per file: a duplicate number here can only
 *  collide within this file, which is what makes the split safer than one shared object. */
export const escrowErrors = {
  // 49xxx escrow.
  ESCROW_FILE_VERSION_CREATE_FAILED: {
    errorCode: 49001,
    errorMessage: t("The new file version could not be created."),
    isDynamic: false,
  },
  ESCROW_PROMOTE_FAILED: {
    errorCode: 49002,
    errorMessage: t("The file could not be promoted out of escrow."),
    isDynamic: false,
  },
  // 49003-49006 came off VALIDATION_FAILED (9004).
  ESCROW_FILE_ID_INVALID: {
    errorCode: 49003,
    errorMessage: t("Invalid file id"),
    isDynamic: false,
  },
  ESCROW_ITEM_NO_UPLOADED_VERSION: {
    errorCode: 49004,
    errorMessage: t("This item has no uploaded version and cannot be promoted out of escrow."),
    isDynamic: false,
  },
  ESCROW_DOCUMENT_ALREADY_IN_FOLDER: {
    errorCode: 49005,
    errorMessage: t("This document already exists in the folder. Upload it as a new version."),
    isDynamic: false,
  },
  ESCROW_MANDATORY_CUSTOM_FIELDS_REQUIRED: {
    errorCode: 49006,
    errorMessage: t("Please fill all the mandatory custom fields."),
    isDynamic: false,
  },
} satisfies Record<string, ErrorCodeMapperEntry>;
